const alertData = [
    {
        color: 'primary'
    },
    {
        color: 'secondary'
    },
    {
        color: 'success',
        icon: 'mdi mdi-check-all'
    },
    {
        color: 'danger',
        icon: 'mdi mdi-block-helper'
    },
    {
        color: 'warning',
        icon: 'mdi mdi-alert-outline'
    },
    {
        color: 'info',
        icon: 'mdi mdi-alert-circle-outline'
    },
    {
        color: 'light'
    },
    {
        color: 'dark'
    }
];

export { alertData };
